export class ProductUnit implements IProductUnit {
    constructor(productUnit?: IProductUnit) {
        if (productUnit) {
            this.unitCode = productUnit.unitCode;
            this.quantity = productUnit.quantity;
        }
    }

    unitCode: string;
    quantity: string;
}

export interface IProductUnit {
    unitCode: string;
    quantity: string;
}